class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input && this.input.form) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce(this.onChange.bind(this), 300));
    }
  }
  toggleResetButton() {
    if (!this.input || !this.resetButton) return;
    this.resetButton.classList.toggle('hidden', this.input.value.length === 0);
  }
  onChange() { this.toggleResetButton(); }
  shouldResetForm() { return !this.querySelector('[aria-selected="true"] a'); }
  onFormReset(event) {
    event.preventDefault();
    if (this.input && this.shouldResetForm()) {
      this.input.value = ''; this.input.focus(); this.toggleResetButton();
    }
  }
}
if (!customElements.get('search-form')) customElements.define('search-form', SearchForm);
